<template>
  <div class="menu-wrapper position-relative py-2" :style="{ backgroundColor: groupFontColor || '#f8f9fa' }">
    <div ref="menuContainer" class="d-flex overflow-auto px-3 no-scrollbar">
      
      <div
        v-for="group in allMenuGroups"
        :key="group.id"
        @click="selectGroup(group)"
        class="menu-item px-3 py-1 text-nowrap flex-shrink-0 font-weight-medium"
        :class="{ active: selectedGroup === group.id }"
        :style="getItemStyle(group)"
      >
        {{ group.nameFR }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    menuGroups: Array,
    groupTitleColor: String,
    groupFontColor: String,
    groupFontFamily: String,
    groupFontSize: String,
    groupFontWeight: String,
    groupFontStyle: String
  },
  data() {
    return {
      selectedGroup: 0
    };
  },
  computed: {
    allMenuGroups() {
      return [{ id: -1, nameFR: 'Tout' }, ...this.menuGroups];
    }
  },
  methods: {
    selectGroup(group) {
      this.selectedGroup = group.id;
      this.$emit("group-selected", group);
    },

    getItemStyle() {
      return {
        color: this.groupTitleColor || "inherit",

        backgroundColor: this.groupFontColor || "inherit",
        fontFamily: this.groupFontFamily || "inherit",
        fontSize: this.groupFontSize || "15px",
        fontWeight: this.groupFontWeight || "400",
        fontStyle: this.groupFontStyle || "normal",
      };
    }
  }
};
</script>

<style scoped>
.menu-wrapper {
  justify-content: center;
  display: flex;
}

.no-scrollbar::-webkit-scrollbar {
  display: none;
}
.no-scrollbar {
  -ms-overflow-style: none;
  scrollbar-width: none;
}

.menu-item {
  cursor: pointer;
  transition: color 0.3s ease, transform 0.3s ease;
}

.menu-item:hover {
  transform: scale(1.05);
  font-weight: 500;
}

.menu-item.active {
  font-weight: 600;
}
</style>
